import { render } from "./AuthorizationOverview.vue?vue&type=template&id=6530f99d&scoped=true"
import script from "./AuthorizationOverview.vue?vue&type=script&lang=js"
export * from "./AuthorizationOverview.vue?vue&type=script&lang=js"

import "./AuthorizationOverview.vue?vue&type=style&index=0&id=6530f99d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6530f99d"]])

export default __exports__